import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";

import css from './OrdersReplaceSingleDishModal.module.css';
import {ordersService} from "../../../../services/orders-services";
import {ordersActions} from "../../../../store/slices/orders-slices";
import {ImageReusable} from "../../../../ui";


const OrdersReplaceSingleDishModal = ({
                                          dish: dishR,
                                          setIsShowReplace,
                                          idForUpdateDishInOrderClient
                                      }) => {
    const dispatch = useDispatch();
    const {trigger, selectedDatesArray} = useSelector((store) => store.orders);

    const {dishId, dish: {name, weight, energy, img}} = dishR;

    const {t, i18n} = useTranslation();
    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name['en'];

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await ordersService.getAllMenuDishesForDate(selectedDatesArray);
                dispatch(ordersActions.changeMenuDishesPacksForDates(res.data));
            } catch (error) {
                console.error(t('modal-toast-fetch-error'), error);
                toast.error(t('modal-toast-fetch-error'));
            }
        };

        getData();
    }, [trigger, selectedDatesArray, dispatch]);


    const handleReplaceClick = async (e) => {
        e.preventDefault();
        try {
            const formatedData = {
                dishId: dishId
            }

            await ordersService.updateDishById(idForUpdateDishInOrderClient, formatedData);
            dispatch(ordersActions.changeTrigger());

            setIsShowReplace(false);
            toast.success('Successfully updated');
        } catch (error) {
            console.error(t('modal-toast-creating-error'), error);
            toast.error(t('modal-toast-creating-error'));
        }
    }


    return (
        <div className={css.wrap} onClick={handleReplaceClick}>
            <div className={css.imgBlock}>
                <ImageReusable src={img} alt="Food Image"/>
            </div>

            <div className={css.name}>
                {displayName}
            </div>

            <div className={css.info}>
                {weight} g/ {energy} kcal
            </div>
        </div>
    );
};

export {OrdersReplaceSingleDishModal};